<template>
    <b-card :title="$translate('filters')" body-class="p-0 mt-3" class="text-center" title-tag="h5">
        <b-card-body class="p-0 mt-3 query-filter">
            <b-row class="p-0 mt-3 mt-12">
                <b-col md="4" cols="12" class="dd text-start">
                    <label for="input-orderType" class="mb-3"><strong>{{ $translate('type') }}</strong></label>
                    <b-form-select class="form-control" id="input-orderType" v-model="orderFilter.type_id" value-field="id"
                        text-field="name" :options="orderTypes">
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate('any_type') }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="4" cols="12" class="mt-3 mt-md-0 dd text-start">
                    <label for="input-officer" class="mb-3"><strong>{{ $translate('officer') }}</strong></label>
                    <b-form-select class="form-control" id="input-officer" v-model="orderFilter.driver_id" value-field="id"
                        text-field="name" :options="officers">
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate('any_officer') }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="4" cols="12" class="mt-3 mt-md-0 dd text-start">
                    <label for="input-status" class="mb-3"><strong>{{ $translate('role') }}</strong></label>
                    <b-form-select class="form-control" id="input-role_id" v-model="orderFilter.role_id" :options="roles"
                        text-field="name" value-field="id" required trim>
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate('select_role') }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="6" cols="12" class="mt-3 text-start">
                    <label for="input-due_from" class="mb-3"><strong>{{ $translate('due_from') }}</strong></label>
                    <b-form-input type="date" id="input-due_from" :max="orderFilter.due_to"
                        v-model="orderFilter.due_from"></b-form-input>
                </b-col>

                <b-col md="6" cols="12" class="mt-3 text-start">
                    <label for="input-due_to" class="mb-3"><strong>{{ $translate('due_to') }}</strong></label>
                    <b-form-input type="date" :min="orderFilter.due_from" id="input-due_to"
                        v-model="orderFilter.due_to"></b-form-input>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    name: 'orders-scheduleFilters',
    data: () => ({}),
    props: ['value', 'orderTypes', 'user', 'officers', 'roles'],

    computed: {
        orderFilter: {
            // getter
            get() {
                return this.value
            },
            // setter
            set(val) {
                this.$emit('input', val)
            },
        },
    },

    watch: {},
}
</script>
